<template>
  <SearchForm></SearchForm>
  <div id="content" class="row g-2 justify-content-center" v-if="journeys.length !== 0">
    <h1 class="col-xxl-7 col-xl-8 col-lg-9 mb-2">Verbindungen</h1>
  </div>
  <div class="row g-2 justify-content-center" v-if="journeys.length !== 0">
    <div class="col-xxl-7 col-xl-8 col-lg-9 mb-5">
      <div v-for="journey in journeys">
        <journey-card :journey="journey"></journey-card>
      </div>
    </div>
  </div>
  <SavedJourneyList></SavedJourneyList>
</template>

<script setup lang="ts">
definePageMeta({ layout: 'default' })

useHead({
  title: 'Verbindungen'
})

import { useMainStore } from '~/stores/main'
import { storeToRefs } from 'pinia'
import JourneyCard from '~/components/JourneyDisplay/JourneyCard.vue'
import SavedJourneyList from '~/components/JourneyDisplay/SavedJourneyList.vue'
import SearchForm from '~/components/SearchForm.vue'

const store = useMainStore()
const { journeys } = storeToRefs(store)
</script>
